module.exports = __webpack_public_path__ + "static/img/1.d05e8d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/1.png
// module id = Bkwh
// module chunks = 0